import React from "react";

const ThirdPartyChart2 = () => {
  return (
    <div className="m-5">
      <iframe
        loading="lazy"
        className="rounded-xl"
        style={{
          width: 332.5,
          height: 250,
          top: 0,
          left: 0,
          padding: 0,
          marginLeft: 0,
        }}
        src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFw1u8qw-s&#x2F;view?embed"
        allowfullscreen="allowfullscreen"
        allow="fullscreen"
      ></iframe>
      {/* <a href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFw1u8qw-s&#x2F;view?utm_content=DAFw1u8qw-s&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link" target="_blank" rel="noopener"></a> */}
    </div>
    // <div className="m-5 w-1/3">
    //   <iframe
    //     loading="lazy"
    //     className="rounded-xl"
    //     style={{
    //       width: 500,
    //       height: 250,
    //       top: 0,
    //       left: 0,
    //       padding: 0,
    //       marginLeft: 0,
    //     }}
    //     src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFw3fklocg&#x2F;view?embed"
    //     allowfullscreen="allowfullscreen"
    //     allow="fullscreen"
    //   ></iframe>
    //   <a
    //     href="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAFw3fklocg&#x2F;view?utm_content=DAFw3fklocg&amp;utm_campaign=designshare&amp;utm_medium=embeds&amp;utm_source=link"
    //     target="_blank"
    //     rel="noopener"
    //   ></a>
    // </div>
  );
};

export default ThirdPartyChart2;
